<mat-form-field class="me-3">
  <input
    matInput
    placeholder="Search For a Unit"
    name="unitsControl"
    [matAutocomplete]="actionAuto"
    [formControl]="unitsControl"
    [(ngModel)]="action.unit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete #actionAuto="matAutocomplete">
    @for (unit of filteredUnits; track unit) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>

<mat-form-field class="me-3">
  <mat-label>Date Range</mat-label>
  <mat-date-range-input [rangePicker]="picker">
    <input
      matStartDate
      placeholder="Start date"
      (dateChange)="changeDate($event)"
    />
    <input
      matEndDate
      placeholder="End date"
      (dateChange)="changeDate($event)"
    />
  </mat-date-range-input>
  <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker" />
  <mat-date-range-picker #picker />
</mat-form-field>

<button
  type="button"
  mat-raised-button
  color="accent"
  class="mx-auto"
  [disabled]="!action.unit"
  (click)="getBridgeAction()"
>
  Get Report
</button>
@if (displayData) {
  <button
    type="button"
    mat-button
    color="primary"
    class="grid-button pull-right"
    [disabled]="!displayData || displayData.length === 0"
    (click)="exportToExcel(bridgeActionGrid)"
  >
    <mat-icon>cloud_download</mat-icon>Download Excel File
  </button>
}

<kendo-grid
  #bridgeActionGrid="kendoGrid"
  class="col-12 mt-3 usage-grid"
  [hidden]="!displayData || displayData.length === 0"
  [kendoGridBinding]="displayData"
  [navigable]="true"
>
  <kendo-grid-column [width]="45">
    <ng-template let-dataItem kendoGridCellTemplate>
      <button
        type="button"
        mat-icon-button
        color="primary"
        matTooltip="View Detail"
        (click)="openDetailModal($event, dataItem)"
      >
        <mat-icon>preview</mat-icon>
      </button>
    </ng-template>
  </kendo-grid-column>
  @for (col of bridgeActionData.headers; track $index) {
    <kendo-grid-column
      [field]="col.DataField"
      [title]="col.Label"
      [hidden]="col.Hidden"
    >
      <!-- @if (
        col.DataField === 'noThanksItems' ||
        col.DataField === 'iLikeItItems' ||
        col.DataField === 'followUpsItems' ||
        col.DataField === 'otherItems'
      ) {
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem[col.DataField].length === 0) {
            None
          }
          @for (item of dataItem[col.DataField]; track $index) {
            @if ($index > 0) {
              <br />
            }
            {{ display(item, $index) }}
          }
        </ng-template>
      } -->
    </kendo-grid-column>
  }
  <kendo-grid-excel fileName="RightBridge-BridgeActionReport.xlsx" />
</kendo-grid>
@if (hiddenItemNum > 0) {
  <div class="table-notes"
    ><p>{{ hiddenItemNum }} unit(s) hidden</p
    ><p>Hidden units have 0 total actions taken</p></div
  >
}
@if (loading) {
  <app-simple-loading [message]="'Loading Report...'" />
}
